// src/errors/errorThrower.ts
import { buildErrorThrower } from "@clerk/shared/error";
var errorThrower = buildErrorThrower({ packageName: "@clerk/vue" });
function setErrorThrowerOptions(options) {
  errorThrower.setMessages(options).setPackageName(options);
}

export {
  errorThrower,
  setErrorThrowerOptions
};
//# sourceMappingURL=chunk-ATMDUXZB.js.map